module.exports = "<input \n  ref=\"inputElement\" \n  class=\"wc-input wc-table-input-edit\" \n  v-if=\"edit\" \n  type=\"text\" \n  v-model=\"value\" \n  v-on:focus=\"editStart\"\n  v-on:blur=\"editComplete\" \n  v-on:keyup.enter.stop=\"editComplete\"\n  v-on:keyup.esc.stop=\"stopEdit(true)\" \n  v-on:keydown.stop\n  v-on:click.stop\n  v-focus\n/>"


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/src/wc-ui/components/table/editors/table-cell-edit-text.html
// module id = 301
// module chunks = 0